/**
 * Generate shareable deep links for duels.
 */

const WEB_BASE = 'https://douevenlift.com';

/** Native deep link for a duel */
export function generateDuelInviteLink(duelId: string): string {
  return `duel://duel/${encodeURIComponent(duelId)}`;
}

/** Web fallback URL for a duel */
export function generateDuelWebLink(duelId: string): string {
  return `${WEB_BASE}/duel/${encodeURIComponent(duelId)}`;
}
